export default __webpack_public_path__ + "static/media/0085.f03a2dca.jpg";